import {
  Box,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { getTrasladoEstadoColor } from "../../../../constants/trasladosEstados";

const formatUbicacion = (provincia, localidad) => {
  const parts = [provincia, localidad].filter(Boolean);
  return parts.length ? parts.join(" - ") : "—";
};

const formatDistancia = (value) => {
  if (value === null || value === undefined) {
    return "—";
  }
  return `${Number(value).toLocaleString("es-AR", { maximumFractionDigits: 1 })} km`;
};

const HistorialTrasladosTramos = ({ trasladoLabel, tramos = [] }) => (
  <Box sx={{ p: 2, bgcolor: "#f7f9fb" }}>
    <Typography variant="subtitle2" gutterBottom>
      Tramos del traslado {trasladoLabel}
    </Typography>
    <Table size="small">
      <TableHead sx={{ bgcolor: "#eef2f6" }}>
        <TableRow>
          <TableCell>Nro Tramo</TableCell>
          <TableCell>Origen</TableCell>
          <TableCell>Destino</TableCell>
          <TableCell>Transporte</TableCell>
          <TableCell>Agencia</TableCell>
          <TableCell>Distancia</TableCell>
          <TableCell>Estado Tramo</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {tramos.map((tramo) => (
          <TableRow key={tramo.idTramo}>
            <TableCell>
              <b>{tramo.nroTramoUnico ?? tramo.nroOrden}</b>
            </TableCell>
            <TableCell>
              {formatUbicacion(tramo.provinciaOrigen, tramo.localidadOrigen)}
            </TableCell>
            <TableCell>
              {formatUbicacion(tramo.provinciaDestino, tramo.localidadDestino)}
            </TableCell>
            <TableCell>{tramo.tipoTransporteNombre || "—"}</TableCell>
            <TableCell>{tramo.agenciaNombre || "—"}</TableCell>
            <TableCell>
              {formatDistancia(tramo.distancia ?? tramo.distanciaKm ?? tramo.distanciaKM)}
            </TableCell>
            <TableCell>
              <Chip
                label={tramo.estadoTramoNombre || "Desconocido"}
                size="small"
                sx={{
                  bgcolor: getTrasladoEstadoColor(tramo.estadoTramoNombre),
                  color: "#fff",
                  fontWeight: "bold",
                }}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

export default HistorialTrasladosTramos;
